import { I18nLabels } from './common';
import { Locale } from './locale';

/**
 * 剧本模式枚举
 * 
 * 重新定义三种模式，移除意图识别逻辑
 */
export enum ScriptMode {
  PROMPT = 'prompt',                    // 自由创作模式：仅通过提示词创建
  FILE_SCRIPT = 'file_script',          // 文件剧本模式：上传剧本文件
  PROJECT_SCRIPT = 'project_script',    // 项目剧本模式：从项目剧本章节创建
  MV = 'mv'                             // MV 模式：上传音乐，音频分析结果存入 uploadedScriptContent
}

export const ScriptModeLabels: I18nLabels<ScriptMode> = {
  [ScriptMode.PROMPT]: { [Locale.ZH_CN]: '自由创作模式', [Locale.EN_US]: 'Free Creation' },
  [ScriptMode.FILE_SCRIPT]: { [Locale.ZH_CN]: '文件剧本模式', [Locale.EN_US]: 'File Script' },
  [ScriptMode.PROJECT_SCRIPT]: { [Locale.ZH_CN]: '项目剧本模式', [Locale.EN_US]: 'Project Script' },
  [ScriptMode.MV]: { [Locale.ZH_CN]: 'MV 生成模式', [Locale.EN_US]: 'MV Generation' },
};

/**
 * @deprecated 意图识别结果已废弃，模式由输入参数直接决定
 */
export interface ScriptIntentResult {
  hasScript: boolean;
  scriptMode: ScriptMode;
  confidence: number;
  reasoning: string;
}
